import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import BalanceCalculator from './BalanceCalculator';

const BalanceInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Balance Transfer Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Balance Transfer Calculator helps you compare the cost of transferring your existing credit card balance to a new card. It provides a detailed analysis of the fees, interest rates, and savings associated with the transfer, helping you make an informed decision about your credit card management.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Current Balance</li>
        <li>Current Interest Rate</li>
        <li>Transfer Fee</li>
        <li>Promotional Rate</li>
        <li>Regular Rate</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator considers various factors to determine the cost-effectiveness of a balance transfer:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Calculates the total transfer cost including fees</li>
        <li>Compares current interest costs with new card costs</li>
        <li>Considers promotional periods and regular rates</li>
        <li>Calculates potential savings</li>
        <li>Provides a detailed cost comparison</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Compare costs of different balance transfer options</li>
        <li>Calculate potential interest savings</li>
        <li>Understand total transfer costs</li>
        <li>Plan repayment strategy</li>
        <li>Make informed credit card decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your current credit card balance, interest rate, and details about the new card's promotional offer to calculate the cost-effectiveness of the balance transfer. The calculator will provide a detailed comparison of costs and potential savings.</p>
    </div>
  );
};

const Balance = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <BalanceCalculator/>
        </div>
        <BalanceInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default Balance;